import { render } from "./stack5DimFollowAgeRange.vue?vue&type=template&id=2ecc423e&scoped=true"
import script from "./stack5DimFollowAgeRange.vue?vue&type=script&lang=js"
export * from "./stack5DimFollowAgeRange.vue?vue&type=script&lang=js"

import "./stack5DimFollowAgeRange.vue?vue&type=style&index=0&id=2ecc423e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ecc423e"]])

export default __exports__